import { ActionSubTypes } from '../../../actions/ActionSubTypes';
import PageBaseReducer from '../../core/PageBaseReducer';

export default PageBaseReducer(ActionSubTypes.PAGE_OYAKKIRATRGENELIAYLIKGELIRDAGILIMI);
